import * as React from 'react';

const Loader: React.FC = () => (
  <div className="loader">
    <span className="loader__pixel"></span>
    <span className="loader__pixel"></span>
    <span className="loader__pixel"></span>
  </div>
);

export default Loader;
